import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as environmentalAspectsServiceClear } from './environmentalAspectsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'environmentalAspects',
  serviceTableName: 'environmentalAspectsService',
  serviceClearFunction: environmentalAspectsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.environmentalAspect]),
});
